export const GT_LOGIN_LABEL = process.env.GT_LOGIN_LABEL || "Login";
export const GT_APP_NAME = "VueTrip";
export const GT_HOSTNAME =
  process.env.GT_HOSTNAME || "https://cpsapi.pinkelephantinternational.com/";
export const GT_ENDPOINT =
  process.env.GT_ENDPOINT ||
  "https://cpsapi.pinkelephantinternational.com/graphql";
export const GT_CONTENT_HUB_ENDPOINT = "http://178.79.143.229:7002/graphql";
export const GT3_ENDPOINT = "http://localhost:3001/graphql";
export const GT_USER_ID = "gt-user-id";
export const GT_AUTH_TOKEN = "gt-auth-token";
export const GT_USER_DATA = "gt-user-data";
export const GT_USER_CONFIG = "gt-user-config";
export const GT_USER_AGENT_ID = "gt-agent-id";
export const GT_USER_AGENT_NAME = "gt-agent-name";
export const GT_ITI_AGENT_CURRENCY = "gt-iti-agent-currency";
export const GT_ITI_BUILDER_VIEW = "gt-iti-builder-view";
export const GT_ITI_BUILDER_VISIBLE_COLS = "gt-iti-builder-visible-cols";
export const GT_ITI_BUILDER_ONE_PAGE = "gt-iti-builder-one-page";
export const GT_LOCAL_SETTINGS = "gt-local-settings";
export const GT_USER_LOGIN_TIME = "gt-user-login-time";
export const REZG_ENDPOINT =
  "http://rez-graph-dev.eu-west-1.elasticbeanstalk.com/graphql";
export const REZG_WSS_ENDPOINT =
  "ws://rez-graph-dev.eu-west-1.elasticbeanstalk.com/";
// update trigger



// WEBPACK FOOTER //
// ./src/constants/settings.js